// Web CRM public auth-flow (StaffSignUp / ProfileCompletion / TierPicker / SignupSuccess /
// SignupCancel) static-UI translations. Split into its own module for file size; the parent
// merges it into the same flat lookup as translations.js. Same rules: STATIC UI CHROME ONLY,
// English default + fallback, never translate dynamic/user/backend data ({business}, {name},
// {tier} are interpolated at render time).

const authExtraTranslations = {
  en: {
    // StaffSignUp — UI chrome
    'staff.registration': 'Staff Registration',
    'staff.joinTeam': 'Join Your Business Team',
    'staff.joinDesc': 'Register as a staff member under your business Brand ID',
    'staff.processTitle': 'Staff Registration Process',
    'staff.process1': 'Enter your business Brand ID (8-digit code from administrator)',
    'staff.process2': 'All staff start with Operator role',
    'staff.process3': 'Administrator can assign different roles later',
    'staff.process4': 'Each business has isolated access to their data',
    'staff.brandIdLabel': 'Business Brand ID *',
    'staff.brandIdPh': 'Enter your Brand ID',
    'staff.verify': 'Verify',
    'staff.getFromAdmin': 'Get this from your business administrator',
    'staff.needBrandId': 'Need a Brand ID?',
    'staff.contactAdminPre': "Contact your business administrator to get your Brand ID. If you're a business owner, ",
    'staff.createBusinessLink': 'create a business account',
    'staff.contactAdminPost': ' instead.',
    'staff.brandIdVerified': 'Brand ID Verified',
    'staff.sectorLabel': 'Sector:',
    'staff.subSectorLabel': 'Sub-Sector:',
    'staff.personalInfo': 'Personal Information',
    'staff.emailLabel': 'Email Address *',
    'staff.emailPh': 'Enter your email',
    'staff.contact': 'Contact',
    'staff.phoneHelper': 'Select your country code, then enter your number. You will use this number to log in via OTP.',
    'staff.defaultRole': 'Default Role Assignment',
    'staff.roleInfo': 'You will be assigned Operator role initially. Your administrator can update your role later.',
    'staff.creating': 'Creating Account...',
    'staff.createAccount': 'Create Staff Account',
    'staff.accountCreated': 'Account Created Successfully!',
    'staff.regDetails': 'Registration Details',
    'staff.businessLabel': 'Business:',
    'staff.brandIdColon': 'Brand ID:',
    'staff.initialRole': 'Initial Role:',
    'staff.activeLogin': 'Your account is active. Log in with your phone number — you will receive an OTP to verify your identity.',
    // StaffSignUp — toasts
    'staff.t.brandRequiredTitle': 'Brand ID required',
    'staff.t.brandRequiredDesc': 'Enter the Brand ID from your administrator.',
    'staff.t.verifiedTitle': 'Brand ID Verified!',
    'staff.t.verifiedDesc': 'You will be registered under {business}',
    'staff.t.invalidBrandTitle': 'Invalid Brand ID',
    'staff.t.invalidBrandDesc': 'Brand ID not found. Please check with your administrator.',
    'staff.t.couldNotVerifyTitle': 'Could Not Verify Brand ID',
    'staff.t.couldNotVerifyDesc': 'Please try again, or contact your administrator.',
    'staff.t.connErrorTitle': 'Connection Error',
    'staff.t.connVerifyDesc': 'Could not reach the server to verify your Brand ID. Please try again.',
    'staff.t.invalidPhoneTitle': 'Invalid phone number',
    'staff.t.invalidPhoneDesc': 'Select your country code and enter a valid phone number.',
    'staff.t.phoneRegisteredTitle': 'Phone Already Registered',
    'staff.t.phoneRegisteredDesc': 'This phone number is already registered under another business account.',
    'staff.t.inviteExpiredTitle': 'Invitation Expired',
    'staff.t.inviteExpiredDesc': 'This invitation has expired. Contact your administrator to request a new invitation.',
    'staff.t.regBlockedTitle': 'Registration Blocked',
    'staff.t.regBlockedDesc': 'Seat limit reached or role unavailable on this plan.',
    'staff.t.brandNotFoundTitle': 'Brand ID Not Found',
    'staff.t.brandNotFoundDesc': 'This Brand ID does not exist. Check with your administrator.',
    'staff.t.regFailedTitle': 'Registration Failed',
    'staff.t.regFailedDesc': 'Unable to complete registration. Please try again.',
    'staff.t.accountCreatedTitle': 'Account Created!',
    'staff.t.accountCreatedDesc': 'Your staff account is active. You can now log in with your phone number.',
    'staff.t.connDesc': 'Could not reach the server. Please try again.',
    // ProfileCompletion
    'profile.title': 'Complete Your Profile',
    'profile.desc': 'Help us personalize your experience by providing your name',
    'profile.firstName': 'First Name *',
    'profile.firstNamePh': 'John',
    'profile.lastName': 'Last Name',
    'profile.lastNamePh': 'Smith',
    'profile.company': 'Company (Optional)',
    'profile.companyPh': 'Your Company Name',
    'profile.saving': 'Saving...',
    'profile.complete': 'Complete Profile',
    'profile.t.nameRequiredTitle': 'Name Required',
    'profile.t.nameRequiredDesc': 'Please enter your first name',
    'profile.t.completedTitle': 'Profile Completed',
    'profile.t.completedDesc': 'Welcome, {name}!',
    'profile.t.updateFailedTitle': 'Update Failed',
    'profile.t.updateFailedDesc': 'Failed to complete profile. Please try again.',
    // TierPicker
    'tier.choosePlan': 'Choose Your Subscription Plan',
    'tier.chooseDesc': 'Select the plan that best fits your business needs',
    'tier.trialTitle': 'Try Servisfy free for 14 days',
    'tier.trialDesc': 'Full Professional features. No card required. Convert to a paid plan anytime before your trial ends.',
    'tier.startingTrial': 'Starting your trial…',
    'tier.startTrial': 'Start 14-Day Free Trial',
    'tier.popular': 'Popular',
    'tier.onRequest': 'On request',
    'tier.users': 'Users:',
    'tier.engagements': 'Engagements:',
    'tier.storage': 'Storage:',
    'tier.selected': 'Selected',
    'tier.selectedLabel': 'Selected:',
    'tier.contactSales': 'Contact sales',
    'tier.customPlanNote': 'Custom plans are tailored — our team will set up your pricing',
    'tier.redirecting': 'Redirecting to Payment…',
    'tier.continuePayment': 'Continue to Payment',
    'tier.securePayment': 'You will be redirected to secure payment processing',
    // SignupSuccess
    'success.confirming': 'Confirming your payment…',
    'success.trialActive': 'Your trial is active!',
    'success.welcome': 'Welcome aboard!',
    'success.paymentIncomplete': 'Payment incomplete',
    'success.stillProcessing': 'Still processing…',
    'success.trialLive': 'Your 14-day free trial is live. Save your Brand ID — your team will use it to sign up.',
    'success.subActive': 'Your subscription is active. Save your Brand ID — your staff will use it to sign up.',
    'success.yourBrandId': 'Your Brand ID',
    'success.trialEnds': 'Trial ends:',
    'success.tierTrial': '{tier} (trial)',
    'success.tierPlan': '{tier} plan',
    'success.continueLogin': 'Continue to Login',
    'success.paymentFailed': "We couldn't confirm your payment. Please try again.",
    'success.backToSignup': 'Back to Signup',
    'success.stillProcessingDesc': 'Payment is still being processed. Check your email for receipt — you can sign in once it clears.',
    // SignupCancel
    'cancel.title': 'Payment cancelled',
    'cancel.desc': 'No charge was made. You can resume signup anytime.',
  },
  es: {
    'staff.registration': 'Registro de personal',
    'staff.joinTeam': 'Únete al equipo de tu empresa',
    'staff.joinDesc': 'Regístrate como miembro del personal con el ID de marca de tu empresa',
    'staff.processTitle': 'Proceso de registro de personal',
    'staff.process1': 'Introduce el ID de marca de tu empresa (código de 8 dígitos del administrador)',
    'staff.process2': 'Todo el personal comienza con el rol de Operador',
    'staff.process3': 'El administrador puede asignar roles diferentes más tarde',
    'staff.process4': 'Cada empresa tiene acceso aislado a sus datos',
    'staff.brandIdLabel': 'ID de marca de la empresa *',
    'staff.brandIdPh': 'Introduce tu ID de marca',
    'staff.verify': 'Verificar',
    'staff.getFromAdmin': 'Solicítalo al administrador de tu empresa',
    'staff.needBrandId': '¿Necesitas un ID de marca?',
    'staff.contactAdminPre': 'Contacta con el administrador de tu empresa para obtener tu ID de marca. Si eres propietario de un negocio, ',
    'staff.createBusinessLink': 'crea una cuenta de empresa',
    'staff.contactAdminPost': ' en su lugar.',
    'staff.brandIdVerified': 'ID de marca verificado',
    'staff.sectorLabel': 'Sector:',
    'staff.subSectorLabel': 'Subsector:',
    'staff.personalInfo': 'Información personal',
    'staff.emailLabel': 'Correo electrónico *',
    'staff.emailPh': 'Introduce tu correo electrónico',
    'staff.contact': 'Contacto',
    'staff.phoneHelper': 'Selecciona tu código de país y luego introduce tu número. Usarás este número para iniciar sesión mediante OTP.',
    'staff.defaultRole': 'Asignación de rol predeterminada',
    'staff.roleInfo': 'Se te asignará el rol de Operador inicialmente. Tu administrador puede actualizar tu rol más tarde.',
    'staff.creating': 'Creando cuenta...',
    'staff.createAccount': 'Crear cuenta de personal',
    'staff.accountCreated': '¡Cuenta creada correctamente!',
    'staff.regDetails': 'Detalles del registro',
    'staff.businessLabel': 'Empresa:',
    'staff.brandIdColon': 'ID de marca:',
    'staff.initialRole': 'Rol inicial:',
    'staff.activeLogin': 'Tu cuenta está activa. Inicia sesión con tu número de teléfono; recibirás un OTP para verificar tu identidad.',
    'staff.t.brandRequiredTitle': 'ID de marca requerido',
    'staff.t.brandRequiredDesc': 'Introduce el ID de marca de tu administrador.',
    'staff.t.verifiedTitle': '¡ID de marca verificado!',
    'staff.t.verifiedDesc': 'Serás registrado en {business}',
    'staff.t.invalidBrandTitle': 'ID de marca no válido',
    'staff.t.invalidBrandDesc': 'ID de marca no encontrado. Consulta con tu administrador.',
    'staff.t.couldNotVerifyTitle': 'No se pudo verificar el ID de marca',
    'staff.t.couldNotVerifyDesc': 'Inténtalo de nuevo o contacta con tu administrador.',
    'staff.t.connErrorTitle': 'Error de conexión',
    'staff.t.connVerifyDesc': 'No se pudo contactar con el servidor para verificar tu ID de marca. Inténtalo de nuevo.',
    'staff.t.invalidPhoneTitle': 'Número de teléfono no válido',
    'staff.t.invalidPhoneDesc': 'Selecciona tu código de país e introduce un número de teléfono válido.',
    'staff.t.phoneRegisteredTitle': 'Teléfono ya registrado',
    'staff.t.phoneRegisteredDesc': 'Este número de teléfono ya está registrado en otra cuenta de empresa.',
    'staff.t.inviteExpiredTitle': 'Invitación caducada',
    'staff.t.inviteExpiredDesc': 'Esta invitación ha caducado. Contacta con tu administrador para solicitar una nueva invitación.',
    'staff.t.regBlockedTitle': 'Registro bloqueado',
    'staff.t.regBlockedDesc': 'Se alcanzó el límite de plazas o el rol no está disponible en este plan.',
    'staff.t.brandNotFoundTitle': 'ID de marca no encontrado',
    'staff.t.brandNotFoundDesc': 'Este ID de marca no existe. Consulta con tu administrador.',
    'staff.t.regFailedTitle': 'Registro fallido',
    'staff.t.regFailedDesc': 'No se pudo completar el registro. Inténtalo de nuevo.',
    'staff.t.accountCreatedTitle': '¡Cuenta creada!',
    'staff.t.accountCreatedDesc': 'Tu cuenta de personal está activa. Ya puedes iniciar sesión con tu número de teléfono.',
    'staff.t.connDesc': 'No se pudo contactar con el servidor. Inténtalo de nuevo.',
    'profile.title': 'Completa tu perfil',
    'profile.desc': 'Ayúdanos a personalizar tu experiencia proporcionando tu nombre',
    'profile.firstName': 'Nombre *',
    'profile.firstNamePh': 'Juan',
    'profile.lastName': 'Apellido',
    'profile.lastNamePh': 'García',
    'profile.company': 'Empresa (opcional)',
    'profile.companyPh': 'Nombre de tu empresa',
    'profile.saving': 'Guardando...',
    'profile.complete': 'Completar perfil',
    'profile.t.nameRequiredTitle': 'Nombre requerido',
    'profile.t.nameRequiredDesc': 'Introduce tu nombre',
    'profile.t.completedTitle': 'Perfil completado',
    'profile.t.completedDesc': '¡Bienvenido, {name}!',
    'profile.t.updateFailedTitle': 'Error al actualizar',
    'profile.t.updateFailedDesc': 'No se pudo completar el perfil. Inténtalo de nuevo.',
    'tier.choosePlan': 'Elige tu plan de suscripción',
    'tier.chooseDesc': 'Selecciona el plan que mejor se adapte a las necesidades de tu empresa',
    'tier.trialTitle': 'Prueba Servisfy gratis durante 14 días',
    'tier.trialDesc': 'Todas las funciones Professional. Sin tarjeta. Cambia a un plan de pago cuando quieras antes de que termine tu prueba.',
    'tier.startingTrial': 'Iniciando tu prueba…',
    'tier.startTrial': 'Iniciar prueba gratis de 14 días',
    'tier.popular': 'Popular',
    'tier.onRequest': 'Bajo petición',
    'tier.users': 'Usuarios:',
    'tier.engagements': 'Interacciones:',
    'tier.storage': 'Almacenamiento:',
    'tier.selected': 'Seleccionado',
    'tier.selectedLabel': 'Seleccionado:',
    'tier.contactSales': 'Contactar con ventas',
    'tier.customPlanNote': 'Los planes personalizados se adaptan a ti: nuestro equipo configurará tu precio',
    'tier.redirecting': 'Redirigiendo al pago…',
    'tier.continuePayment': 'Continuar al pago',
    'tier.securePayment': 'Serás redirigido a un procesamiento de pago seguro',
    'success.confirming': 'Confirmando tu pago…',
    'success.trialActive': '¡Tu prueba está activa!',
    'success.welcome': '¡Bienvenido a bordo!',
    'success.paymentIncomplete': 'Pago incompleto',
    'success.stillProcessing': 'Aún procesando…',
    'success.trialLive': 'Tu prueba gratis de 14 días está activa. Guarda tu ID de marca: tu equipo lo usará para registrarse.',
    'success.subActive': 'Tu suscripción está activa. Guarda tu ID de marca: tu personal lo usará para registrarse.',
    'success.yourBrandId': 'Tu ID de marca',
    'success.trialEnds': 'La prueba termina:',
    'success.tierTrial': '{tier} (prueba)',
    'success.tierPlan': 'Plan {tier}',
    'success.continueLogin': 'Continuar al inicio de sesión',
    'success.paymentFailed': 'No pudimos confirmar tu pago. Inténtalo de nuevo.',
    'success.backToSignup': 'Volver al registro',
    'success.stillProcessingDesc': 'El pago aún se está procesando. Revisa tu correo electrónico para el recibo; podrás iniciar sesión cuando se complete.',
    'cancel.title': 'Pago cancelado',
    'cancel.desc': 'No se realizó ningún cargo. Puedes reanudar el registro cuando quieras.',
  },
  fr: {
    'staff.registration': 'Inscription du personnel',
    'staff.joinTeam': "Rejoignez l'équipe de votre entreprise",
    'staff.joinDesc': "Inscrivez-vous en tant que membre du personnel avec l'ID de marque de votre entreprise",
    'staff.processTitle': "Processus d'inscription du personnel",
    'staff.process1': "Saisissez l'ID de marque de votre entreprise (code à 8 chiffres de l'administrateur)",
    'staff.process2': 'Tout le personnel commence avec le rôle Opérateur',
    'staff.process3': "L'administrateur peut attribuer d'autres rôles ultérieurement",
    'staff.process4': 'Chaque entreprise dispose d\'un accès isolé à ses données',
    'staff.brandIdLabel': "ID de marque de l'entreprise *",
    'staff.brandIdPh': 'Saisissez votre ID de marque',
    'staff.verify': 'Vérifier',
    'staff.getFromAdmin': "Obtenez-le auprès de l'administrateur de votre entreprise",
    'staff.needBrandId': "Besoin d'un ID de marque ?",
    'staff.contactAdminPre': "Contactez l'administrateur de votre entreprise pour obtenir votre ID de marque. Si vous êtes propriétaire d'une entreprise, ",
    'staff.createBusinessLink': "créez un compte d'entreprise",
    'staff.contactAdminPost': ' à la place.',
    'staff.brandIdVerified': 'ID de marque vérifié',
    'staff.sectorLabel': 'Secteur :',
    'staff.subSectorLabel': 'Sous-secteur :',
    'staff.personalInfo': 'Informations personnelles',
    'staff.emailLabel': 'Adresse e-mail *',
    'staff.emailPh': 'Saisissez votre e-mail',
    'staff.contact': 'Contact',
    'staff.phoneHelper': 'Sélectionnez votre indicatif pays, puis saisissez votre numéro. Vous utiliserez ce numéro pour vous connecter via OTP.',
    'staff.defaultRole': 'Attribution du rôle par défaut',
    'staff.roleInfo': 'Le rôle Opérateur vous sera attribué initialement. Votre administrateur pourra modifier votre rôle ultérieurement.',
    'staff.creating': 'Création du compte...',
    'staff.createAccount': 'Créer un compte du personnel',
    'staff.accountCreated': 'Compte créé avec succès !',
    'staff.regDetails': "Détails de l'inscription",
    'staff.businessLabel': 'Entreprise :',
    'staff.brandIdColon': 'ID de marque :',
    'staff.initialRole': 'Rôle initial :',
    'staff.activeLogin': 'Votre compte est actif. Connectez-vous avec votre numéro de téléphone ; vous recevrez un OTP pour vérifier votre identité.',
    'staff.t.brandRequiredTitle': 'ID de marque requis',
    'staff.t.brandRequiredDesc': "Saisissez l'ID de marque fourni par votre administrateur.",
    'staff.t.verifiedTitle': 'ID de marque vérifié !',
    'staff.t.verifiedDesc': 'Vous serez inscrit sous {business}',
    'staff.t.invalidBrandTitle': 'ID de marque non valide',
    'staff.t.invalidBrandDesc': 'ID de marque introuvable. Veuillez vérifier auprès de votre administrateur.',
    'staff.t.couldNotVerifyTitle': "Impossible de vérifier l'ID de marque",
    'staff.t.couldNotVerifyDesc': 'Veuillez réessayer ou contacter votre administrateur.',
    'staff.t.connErrorTitle': 'Erreur de connexion',
    'staff.t.connVerifyDesc': "Impossible de joindre le serveur pour vérifier votre ID de marque. Veuillez réessayer.",
    'staff.t.invalidPhoneTitle': 'Numéro de téléphone non valide',
    'staff.t.invalidPhoneDesc': 'Sélectionnez votre indicatif pays et saisissez un numéro de téléphone valide.',
    'staff.t.phoneRegisteredTitle': 'Téléphone déjà enregistré',
    'staff.t.phoneRegisteredDesc': "Ce numéro de téléphone est déjà enregistré sous un autre compte d'entreprise.",
    'staff.t.inviteExpiredTitle': 'Invitation expirée',
    'staff.t.inviteExpiredDesc': 'Cette invitation a expiré. Contactez votre administrateur pour demander une nouvelle invitation.',
    'staff.t.regBlockedTitle': 'Inscription bloquée',
    'staff.t.regBlockedDesc': 'Limite de sièges atteinte ou rôle indisponible sur ce forfait.',
    'staff.t.brandNotFoundTitle': 'ID de marque introuvable',
    'staff.t.brandNotFoundDesc': "Cet ID de marque n'existe pas. Vérifiez auprès de votre administrateur.",
    'staff.t.regFailedTitle': "Échec de l'inscription",
    'staff.t.regFailedDesc': "Impossible de terminer l'inscription. Veuillez réessayer.",
    'staff.t.accountCreatedTitle': 'Compte créé !',
    'staff.t.accountCreatedDesc': 'Votre compte du personnel est actif. Vous pouvez désormais vous connecter avec votre numéro de téléphone.',
    'staff.t.connDesc': 'Impossible de joindre le serveur. Veuillez réessayer.',
    'profile.title': 'Complétez votre profil',
    'profile.desc': 'Aidez-nous à personnaliser votre expérience en indiquant votre nom',
    'profile.firstName': 'Prénom *',
    'profile.firstNamePh': 'Jean',
    'profile.lastName': 'Nom',
    'profile.lastNamePh': 'Dupont',
    'profile.company': 'Entreprise (facultatif)',
    'profile.companyPh': 'Nom de votre entreprise',
    'profile.saving': 'Enregistrement...',
    'profile.complete': 'Compléter le profil',
    'profile.t.nameRequiredTitle': 'Nom requis',
    'profile.t.nameRequiredDesc': 'Veuillez saisir votre prénom',
    'profile.t.completedTitle': 'Profil complété',
    'profile.t.completedDesc': 'Bienvenue, {name} !',
    'profile.t.updateFailedTitle': 'Échec de la mise à jour',
    'profile.t.updateFailedDesc': 'Impossible de compléter le profil. Veuillez réessayer.',
    'tier.choosePlan': "Choisissez votre forfait d'abonnement",
    'tier.chooseDesc': 'Sélectionnez le forfait qui correspond le mieux aux besoins de votre entreprise',
    'tier.trialTitle': 'Essayez Servisfy gratuitement pendant 14 jours',
    'tier.trialDesc': 'Toutes les fonctionnalités Professional. Sans carte. Passez à un forfait payant à tout moment avant la fin de votre essai.',
    'tier.startingTrial': 'Démarrage de votre essai…',
    'tier.startTrial': "Démarrer l'essai gratuit de 14 jours",
    'tier.popular': 'Populaire',
    'tier.onRequest': 'Sur demande',
    'tier.users': 'Utilisateurs :',
    'tier.engagements': 'Interactions :',
    'tier.storage': 'Stockage :',
    'tier.selected': 'Sélectionné',
    'tier.selectedLabel': 'Sélectionné :',
    'tier.contactSales': 'Contacter le service commercial',
    'tier.customPlanNote': 'Les forfaits personnalisés sont sur mesure : notre équipe configurera votre tarification',
    'tier.redirecting': 'Redirection vers le paiement…',
    'tier.continuePayment': 'Continuer vers le paiement',
    'tier.securePayment': 'Vous serez redirigé vers un traitement de paiement sécurisé',
    'success.confirming': 'Confirmation de votre paiement…',
    'success.trialActive': 'Votre essai est actif !',
    'success.welcome': 'Bienvenue à bord !',
    'success.paymentIncomplete': 'Paiement incomplet',
    'success.stillProcessing': 'Traitement en cours…',
    'success.trialLive': "Votre essai gratuit de 14 jours est actif. Enregistrez votre ID de marque : votre équipe l'utilisera pour s'inscrire.",
    'success.subActive': "Votre abonnement est actif. Enregistrez votre ID de marque : votre personnel l'utilisera pour s'inscrire.",
    'success.yourBrandId': 'Votre ID de marque',
    'success.trialEnds': "Fin de l'essai :",
    'success.tierTrial': '{tier} (essai)',
    'success.tierPlan': 'Forfait {tier}',
    'success.continueLogin': 'Continuer vers la connexion',
    'success.paymentFailed': "Nous n'avons pas pu confirmer votre paiement. Veuillez réessayer.",
    'success.backToSignup': "Retour à l'inscription",
    'success.stillProcessingDesc': 'Le paiement est toujours en cours de traitement. Vérifiez votre e-mail pour le reçu ; vous pourrez vous connecter une fois validé.',
    'cancel.title': 'Paiement annulé',
    'cancel.desc': "Aucun débit n'a été effectué. Vous pouvez reprendre l'inscription à tout moment.",
  },
  pt: {
    'staff.registration': 'Registro de equipe',
    'staff.joinTeam': 'Junte-se à equipe da sua empresa',
    'staff.joinDesc': 'Registre-se como membro da equipe com o ID de marca da sua empresa',
    'staff.processTitle': 'Processo de registro de equipe',
    'staff.process1': 'Insira o ID de marca da sua empresa (código de 8 dígitos do administrador)',
    'staff.process2': 'Toda a equipe começa com a função de Operador',
    'staff.process3': 'O administrador pode atribuir funções diferentes mais tarde',
    'staff.process4': 'Cada empresa tem acesso isolado aos seus dados',
    'staff.brandIdLabel': 'ID de marca da empresa *',
    'staff.brandIdPh': 'Insira seu ID de marca',
    'staff.verify': 'Verificar',
    'staff.getFromAdmin': 'Obtenha isso com o administrador da sua empresa',
    'staff.needBrandId': 'Precisa de um ID de marca?',
    'staff.contactAdminPre': 'Entre em contato com o administrador da sua empresa para obter seu ID de marca. Se você é proprietário de um negócio, ',
    'staff.createBusinessLink': 'crie uma conta empresarial',
    'staff.contactAdminPost': ' em vez disso.',
    'staff.brandIdVerified': 'ID de marca verificado',
    'staff.sectorLabel': 'Setor:',
    'staff.subSectorLabel': 'Subsetor:',
    'staff.personalInfo': 'Informações pessoais',
    'staff.emailLabel': 'Endereço de e-mail *',
    'staff.emailPh': 'Insira seu e-mail',
    'staff.contact': 'Contato',
    'staff.phoneHelper': 'Selecione o código do seu país e insira seu número. Você usará esse número para entrar via OTP.',
    'staff.defaultRole': 'Atribuição de função padrão',
    'staff.roleInfo': 'Você receberá a função de Operador inicialmente. Seu administrador pode atualizar sua função mais tarde.',
    'staff.creating': 'Criando conta...',
    'staff.createAccount': 'Criar conta de equipe',
    'staff.accountCreated': 'Conta criada com sucesso!',
    'staff.regDetails': 'Detalhes do registro',
    'staff.businessLabel': 'Empresa:',
    'staff.brandIdColon': 'ID de marca:',
    'staff.initialRole': 'Função inicial:',
    'staff.activeLogin': 'Sua conta está ativa. Entre com seu número de telefone; você receberá um OTP para verificar sua identidade.',
    'staff.t.brandRequiredTitle': 'ID de marca obrigatório',
    'staff.t.brandRequiredDesc': 'Insira o ID de marca fornecido pelo seu administrador.',
    'staff.t.verifiedTitle': 'ID de marca verificado!',
    'staff.t.verifiedDesc': 'Você será registrado em {business}',
    'staff.t.invalidBrandTitle': 'ID de marca inválido',
    'staff.t.invalidBrandDesc': 'ID de marca não encontrado. Verifique com seu administrador.',
    'staff.t.couldNotVerifyTitle': 'Não foi possível verificar o ID de marca',
    'staff.t.couldNotVerifyDesc': 'Tente novamente ou entre em contato com seu administrador.',
    'staff.t.connErrorTitle': 'Erro de conexão',
    'staff.t.connVerifyDesc': 'Não foi possível acessar o servidor para verificar seu ID de marca. Tente novamente.',
    'staff.t.invalidPhoneTitle': 'Número de telefone inválido',
    'staff.t.invalidPhoneDesc': 'Selecione o código do seu país e insira um número de telefone válido.',
    'staff.t.phoneRegisteredTitle': 'Telefone já registrado',
    'staff.t.phoneRegisteredDesc': 'Este número de telefone já está registrado em outra conta empresarial.',
    'staff.t.inviteExpiredTitle': 'Convite expirado',
    'staff.t.inviteExpiredDesc': 'Este convite expirou. Entre em contato com seu administrador para solicitar um novo convite.',
    'staff.t.regBlockedTitle': 'Registro bloqueado',
    'staff.t.regBlockedDesc': 'Limite de assentos atingido ou função indisponível neste plano.',
    'staff.t.brandNotFoundTitle': 'ID de marca não encontrado',
    'staff.t.brandNotFoundDesc': 'Este ID de marca não existe. Verifique com seu administrador.',
    'staff.t.regFailedTitle': 'Falha no registro',
    'staff.t.regFailedDesc': 'Não foi possível concluir o registro. Tente novamente.',
    'staff.t.accountCreatedTitle': 'Conta criada!',
    'staff.t.accountCreatedDesc': 'Sua conta de equipe está ativa. Agora você pode entrar com seu número de telefone.',
    'staff.t.connDesc': 'Não foi possível acessar o servidor. Tente novamente.',
    'profile.title': 'Complete seu perfil',
    'profile.desc': 'Ajude-nos a personalizar sua experiência informando seu nome',
    'profile.firstName': 'Nome *',
    'profile.firstNamePh': 'João',
    'profile.lastName': 'Sobrenome',
    'profile.lastNamePh': 'Silva',
    'profile.company': 'Empresa (opcional)',
    'profile.companyPh': 'Nome da sua empresa',
    'profile.saving': 'Salvando...',
    'profile.complete': 'Concluir perfil',
    'profile.t.nameRequiredTitle': 'Nome obrigatório',
    'profile.t.nameRequiredDesc': 'Insira seu nome',
    'profile.t.completedTitle': 'Perfil concluído',
    'profile.t.completedDesc': 'Bem-vindo, {name}!',
    'profile.t.updateFailedTitle': 'Falha na atualização',
    'profile.t.updateFailedDesc': 'Não foi possível concluir o perfil. Tente novamente.',
    'tier.choosePlan': 'Escolha seu plano de assinatura',
    'tier.chooseDesc': 'Selecione o plano que melhor atende às necessidades da sua empresa',
    'tier.trialTitle': 'Experimente o Servisfy grátis por 14 dias',
    'tier.trialDesc': 'Todos os recursos Professional. Sem cartão. Mude para um plano pago quando quiser antes do fim do seu teste.',
    'tier.startingTrial': 'Iniciando seu teste…',
    'tier.startTrial': 'Iniciar teste grátis de 14 dias',
    'tier.popular': 'Popular',
    'tier.onRequest': 'Sob consulta',
    'tier.users': 'Usuários:',
    'tier.engagements': 'Interações:',
    'tier.storage': 'Armazenamento:',
    'tier.selected': 'Selecionado',
    'tier.selectedLabel': 'Selecionado:',
    'tier.contactSales': 'Falar com vendas',
    'tier.customPlanNote': 'Planos personalizados são sob medida: nossa equipe configurará seu preço',
    'tier.redirecting': 'Redirecionando para o pagamento…',
    'tier.continuePayment': 'Continuar para o pagamento',
    'tier.securePayment': 'Você será redirecionado para um processamento de pagamento seguro',
    'success.confirming': 'Confirmando seu pagamento…',
    'success.trialActive': 'Seu teste está ativo!',
    'success.welcome': 'Bem-vindo a bordo!',
    'success.paymentIncomplete': 'Pagamento incompleto',
    'success.stillProcessing': 'Ainda processando…',
    'success.trialLive': 'Seu teste grátis de 14 dias está ativo. Salve seu ID de marca: sua equipe o usará para se registrar.',
    'success.subActive': 'Sua assinatura está ativa. Salve seu ID de marca: sua equipe o usará para se registrar.',
    'success.yourBrandId': 'Seu ID de marca',
    'success.trialEnds': 'O teste termina:',
    'success.tierTrial': '{tier} (teste)',
    'success.tierPlan': 'Plano {tier}',
    'success.continueLogin': 'Continuar para o login',
    'success.paymentFailed': 'Não conseguimos confirmar seu pagamento. Tente novamente.',
    'success.backToSignup': 'Voltar ao registro',
    'success.stillProcessingDesc': 'O pagamento ainda está sendo processado. Verifique seu e-mail para o recibo; você poderá entrar assim que for concluído.',
    'cancel.title': 'Pagamento cancelado',
    'cancel.desc': 'Nenhuma cobrança foi feita. Você pode retomar o registro a qualquer momento.',
  },
  de: {
    'staff.registration': 'Mitarbeiterregistrierung',
    'staff.joinTeam': 'Treten Sie dem Team Ihres Unternehmens bei',
    'staff.joinDesc': 'Registrieren Sie sich als Mitarbeiter mit der Marken-ID Ihres Unternehmens',
    'staff.processTitle': 'Ablauf der Mitarbeiterregistrierung',
    'staff.process1': 'Geben Sie die Marken-ID Ihres Unternehmens ein (8-stelliger Code vom Administrator)',
    'staff.process2': 'Alle Mitarbeiter beginnen mit der Rolle Operator',
    'staff.process3': 'Der Administrator kann später andere Rollen zuweisen',
    'staff.process4': 'Jedes Unternehmen hat isolierten Zugriff auf seine Daten',
    'staff.brandIdLabel': 'Marken-ID des Unternehmens *',
    'staff.brandIdPh': 'Geben Sie Ihre Marken-ID ein',
    'staff.verify': 'Überprüfen',
    'staff.getFromAdmin': 'Erhalten Sie diese von Ihrem Unternehmensadministrator',
    'staff.needBrandId': 'Benötigen Sie eine Marken-ID?',
    'staff.contactAdminPre': 'Wenden Sie sich an Ihren Unternehmensadministrator, um Ihre Marken-ID zu erhalten. Wenn Sie Geschäftsinhaber sind, ',
    'staff.createBusinessLink': 'erstellen Sie ein Unternehmenskonto',
    'staff.contactAdminPost': ' stattdessen.',
    'staff.brandIdVerified': 'Marken-ID verifiziert',
    'staff.sectorLabel': 'Branche:',
    'staff.subSectorLabel': 'Unterbranche:',
    'staff.personalInfo': 'Persönliche Informationen',
    'staff.emailLabel': 'E-Mail-Adresse *',
    'staff.emailPh': 'Geben Sie Ihre E-Mail ein',
    'staff.contact': 'Kontakt',
    'staff.phoneHelper': 'Wählen Sie Ihre Ländervorwahl und geben Sie Ihre Nummer ein. Mit dieser Nummer melden Sie sich per OTP an.',
    'staff.defaultRole': 'Standard-Rollenzuweisung',
    'staff.roleInfo': 'Ihnen wird zunächst die Rolle Operator zugewiesen. Ihr Administrator kann Ihre Rolle später aktualisieren.',
    'staff.creating': 'Konto wird erstellt...',
    'staff.createAccount': 'Mitarbeiterkonto erstellen',
    'staff.accountCreated': 'Konto erfolgreich erstellt!',
    'staff.regDetails': 'Registrierungsdetails',
    'staff.businessLabel': 'Unternehmen:',
    'staff.brandIdColon': 'Marken-ID:',
    'staff.initialRole': 'Anfangsrolle:',
    'staff.activeLogin': 'Ihr Konto ist aktiv. Melden Sie sich mit Ihrer Telefonnummer an; Sie erhalten ein OTP zur Bestätigung Ihrer Identität.',
    'staff.t.brandRequiredTitle': 'Marken-ID erforderlich',
    'staff.t.brandRequiredDesc': 'Geben Sie die Marken-ID von Ihrem Administrator ein.',
    'staff.t.verifiedTitle': 'Marken-ID verifiziert!',
    'staff.t.verifiedDesc': 'Sie werden unter {business} registriert',
    'staff.t.invalidBrandTitle': 'Ungültige Marken-ID',
    'staff.t.invalidBrandDesc': 'Marken-ID nicht gefunden. Bitte wenden Sie sich an Ihren Administrator.',
    'staff.t.couldNotVerifyTitle': 'Marken-ID konnte nicht überprüft werden',
    'staff.t.couldNotVerifyDesc': 'Bitte versuchen Sie es erneut oder wenden Sie sich an Ihren Administrator.',
    'staff.t.connErrorTitle': 'Verbindungsfehler',
    'staff.t.connVerifyDesc': 'Der Server konnte zur Überprüfung Ihrer Marken-ID nicht erreicht werden. Bitte versuchen Sie es erneut.',
    'staff.t.invalidPhoneTitle': 'Ungültige Telefonnummer',
    'staff.t.invalidPhoneDesc': 'Wählen Sie Ihre Ländervorwahl und geben Sie eine gültige Telefonnummer ein.',
    'staff.t.phoneRegisteredTitle': 'Telefon bereits registriert',
    'staff.t.phoneRegisteredDesc': 'Diese Telefonnummer ist bereits unter einem anderen Unternehmenskonto registriert.',
    'staff.t.inviteExpiredTitle': 'Einladung abgelaufen',
    'staff.t.inviteExpiredDesc': 'Diese Einladung ist abgelaufen. Wenden Sie sich an Ihren Administrator, um eine neue Einladung anzufordern.',
    'staff.t.regBlockedTitle': 'Registrierung blockiert',
    'staff.t.regBlockedDesc': 'Sitzplatzlimit erreicht oder Rolle in diesem Tarif nicht verfügbar.',
    'staff.t.brandNotFoundTitle': 'Marken-ID nicht gefunden',
    'staff.t.brandNotFoundDesc': 'Diese Marken-ID existiert nicht. Wenden Sie sich an Ihren Administrator.',
    'staff.t.regFailedTitle': 'Registrierung fehlgeschlagen',
    'staff.t.regFailedDesc': 'Registrierung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
    'staff.t.accountCreatedTitle': 'Konto erstellt!',
    'staff.t.accountCreatedDesc': 'Ihr Mitarbeiterkonto ist aktiv. Sie können sich jetzt mit Ihrer Telefonnummer anmelden.',
    'staff.t.connDesc': 'Der Server konnte nicht erreicht werden. Bitte versuchen Sie es erneut.',
    'profile.title': 'Vervollständigen Sie Ihr Profil',
    'profile.desc': 'Helfen Sie uns, Ihr Erlebnis zu personalisieren, indem Sie Ihren Namen angeben',
    'profile.firstName': 'Vorname *',
    'profile.firstNamePh': 'Max',
    'profile.lastName': 'Nachname',
    'profile.lastNamePh': 'Mustermann',
    'profile.company': 'Unternehmen (optional)',
    'profile.companyPh': 'Name Ihres Unternehmens',
    'profile.saving': 'Wird gespeichert...',
    'profile.complete': 'Profil vervollständigen',
    'profile.t.nameRequiredTitle': 'Name erforderlich',
    'profile.t.nameRequiredDesc': 'Bitte geben Sie Ihren Vornamen ein',
    'profile.t.completedTitle': 'Profil vervollständigt',
    'profile.t.completedDesc': 'Willkommen, {name}!',
    'profile.t.updateFailedTitle': 'Aktualisierung fehlgeschlagen',
    'profile.t.updateFailedDesc': 'Profil konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
    'tier.choosePlan': 'Wählen Sie Ihren Abonnementplan',
    'tier.chooseDesc': 'Wählen Sie den Plan, der am besten zu den Anforderungen Ihres Unternehmens passt',
    'tier.trialTitle': 'Testen Sie Servisfy 14 Tage lang kostenlos',
    'tier.trialDesc': 'Alle Professional-Funktionen. Keine Karte erforderlich. Wechseln Sie jederzeit vor Ablauf Ihrer Testphase zu einem kostenpflichtigen Plan.',
    'tier.startingTrial': 'Ihre Testphase wird gestartet…',
    'tier.startTrial': '14-tägige kostenlose Testphase starten',
    'tier.popular': 'Beliebt',
    'tier.onRequest': 'Auf Anfrage',
    'tier.users': 'Benutzer:',
    'tier.engagements': 'Interaktionen:',
    'tier.storage': 'Speicher:',
    'tier.selected': 'Ausgewählt',
    'tier.selectedLabel': 'Ausgewählt:',
    'tier.contactSales': 'Vertrieb kontaktieren',
    'tier.customPlanNote': 'Individuelle Pläne werden maßgeschneidert – unser Team richtet Ihre Preise ein',
    'tier.redirecting': 'Weiterleitung zur Zahlung…',
    'tier.continuePayment': 'Weiter zur Zahlung',
    'tier.securePayment': 'Sie werden zu einer sicheren Zahlungsabwicklung weitergeleitet',
    'success.confirming': 'Ihre Zahlung wird bestätigt…',
    'success.trialActive': 'Ihre Testphase ist aktiv!',
    'success.welcome': 'Willkommen an Bord!',
    'success.paymentIncomplete': 'Zahlung unvollständig',
    'success.stillProcessing': 'Wird noch verarbeitet…',
    'success.trialLive': 'Ihre 14-tägige kostenlose Testphase ist aktiv. Speichern Sie Ihre Marken-ID – Ihr Team verwendet sie zur Registrierung.',
    'success.subActive': 'Ihr Abonnement ist aktiv. Speichern Sie Ihre Marken-ID – Ihre Mitarbeiter verwenden sie zur Registrierung.',
    'success.yourBrandId': 'Ihre Marken-ID',
    'success.trialEnds': 'Testphase endet:',
    'success.tierTrial': '{tier} (Testphase)',
    'success.tierPlan': '{tier}-Plan',
    'success.continueLogin': 'Weiter zur Anmeldung',
    'success.paymentFailed': 'Wir konnten Ihre Zahlung nicht bestätigen. Bitte versuchen Sie es erneut.',
    'success.backToSignup': 'Zurück zur Registrierung',
    'success.stillProcessingDesc': 'Die Zahlung wird noch verarbeitet. Prüfen Sie Ihre E-Mails auf die Quittung; Sie können sich anmelden, sobald sie abgeschlossen ist.',
    'cancel.title': 'Zahlung abgebrochen',
    'cancel.desc': 'Es wurde keine Zahlung vorgenommen. Sie können die Registrierung jederzeit fortsetzen.',
  },
  it: {
    'staff.registration': 'Registrazione del personale',
    'staff.joinTeam': 'Unisciti al team della tua azienda',
    'staff.joinDesc': "Registrati come membro del personale con l'ID marchio della tua azienda",
    'staff.processTitle': 'Processo di registrazione del personale',
    'staff.process1': "Inserisci l'ID marchio della tua azienda (codice a 8 cifre fornito dall'amministratore)",
    'staff.process2': 'Tutto il personale inizia con il ruolo di Operatore',
    'staff.process3': "L'amministratore può assegnare ruoli diversi in seguito",
    'staff.process4': 'Ogni azienda ha accesso isolato ai propri dati',
    'staff.brandIdLabel': "ID marchio dell'azienda *",
    'staff.brandIdPh': 'Inserisci il tuo ID marchio',
    'staff.verify': 'Verifica',
    'staff.getFromAdmin': "Richiedilo all'amministratore della tua azienda",
    'staff.needBrandId': 'Ti serve un ID marchio?',
    'staff.contactAdminPre': "Contatta l'amministratore della tua azienda per ottenere il tuo ID marchio. Se sei titolare di un'attività, ",
    'staff.createBusinessLink': 'crea un account aziendale',
    'staff.contactAdminPost': ' invece.',
    'staff.brandIdVerified': 'ID marchio verificato',
    'staff.sectorLabel': 'Settore:',
    'staff.subSectorLabel': 'Sottosettore:',
    'staff.personalInfo': 'Informazioni personali',
    'staff.emailLabel': 'Indirizzo email *',
    'staff.emailPh': 'Inserisci la tua email',
    'staff.contact': 'Contatto',
    'staff.phoneHelper': 'Seleziona il prefisso internazionale e inserisci il tuo numero. Utilizzerai questo numero per accedere tramite OTP.',
    'staff.defaultRole': 'Assegnazione ruolo predefinita',
    'staff.roleInfo': 'Ti verrà assegnato inizialmente il ruolo di Operatore. Il tuo amministratore potrà aggiornare il tuo ruolo in seguito.',
    'staff.creating': "Creazione dell'account...",
    'staff.createAccount': 'Crea account del personale',
    'staff.accountCreated': 'Account creato con successo!',
    'staff.regDetails': 'Dettagli della registrazione',
    'staff.businessLabel': 'Azienda:',
    'staff.brandIdColon': 'ID marchio:',
    'staff.initialRole': 'Ruolo iniziale:',
    'staff.activeLogin': 'Il tuo account è attivo. Accedi con il tuo numero di telefono; riceverai un OTP per verificare la tua identità.',
    'staff.t.brandRequiredTitle': 'ID marchio obbligatorio',
    'staff.t.brandRequiredDesc': "Inserisci l'ID marchio fornito dal tuo amministratore.",
    'staff.t.verifiedTitle': 'ID marchio verificato!',
    'staff.t.verifiedDesc': 'Verrai registrato con {business}',
    'staff.t.invalidBrandTitle': 'ID marchio non valido',
    'staff.t.invalidBrandDesc': 'ID marchio non trovato. Verifica con il tuo amministratore.',
    'staff.t.couldNotVerifyTitle': "Impossibile verificare l'ID marchio",
    'staff.t.couldNotVerifyDesc': 'Riprova o contatta il tuo amministratore.',
    'staff.t.connErrorTitle': 'Errore di connessione',
    'staff.t.connVerifyDesc': 'Impossibile raggiungere il server per verificare il tuo ID marchio. Riprova.',
    'staff.t.invalidPhoneTitle': 'Numero di telefono non valido',
    'staff.t.invalidPhoneDesc': 'Seleziona il prefisso internazionale e inserisci un numero di telefono valido.',
    'staff.t.phoneRegisteredTitle': 'Telefono già registrato',
    'staff.t.phoneRegisteredDesc': 'Questo numero di telefono è già registrato con un altro account aziendale.',
    'staff.t.inviteExpiredTitle': 'Invito scaduto',
    'staff.t.inviteExpiredDesc': 'Questo invito è scaduto. Contatta il tuo amministratore per richiedere un nuovo invito.',
    'staff.t.regBlockedTitle': 'Registrazione bloccata',
    'staff.t.regBlockedDesc': 'Limite di posti raggiunto o ruolo non disponibile con questo piano.',
    'staff.t.brandNotFoundTitle': 'ID marchio non trovato',
    'staff.t.brandNotFoundDesc': 'Questo ID marchio non esiste. Verifica con il tuo amministratore.',
    'staff.t.regFailedTitle': 'Registrazione non riuscita',
    'staff.t.regFailedDesc': 'Impossibile completare la registrazione. Riprova.',
    'staff.t.accountCreatedTitle': 'Account creato!',
    'staff.t.accountCreatedDesc': 'Il tuo account del personale è attivo. Ora puoi accedere con il tuo numero di telefono.',
    'staff.t.connDesc': 'Impossibile raggiungere il server. Riprova.',
    'profile.title': 'Completa il tuo profilo',
    'profile.desc': 'Aiutaci a personalizzare la tua esperienza fornendo il tuo nome',
    'profile.firstName': 'Nome *',
    'profile.firstNamePh': 'Mario',
    'profile.lastName': 'Cognome',
    'profile.lastNamePh': 'Rossi',
    'profile.company': 'Azienda (facoltativo)',
    'profile.companyPh': 'Nome della tua azienda',
    'profile.saving': 'Salvataggio...',
    'profile.complete': 'Completa il profilo',
    'profile.t.nameRequiredTitle': 'Nome obbligatorio',
    'profile.t.nameRequiredDesc': 'Inserisci il tuo nome',
    'profile.t.completedTitle': 'Profilo completato',
    'profile.t.completedDesc': 'Benvenuto, {name}!',
    'profile.t.updateFailedTitle': 'Aggiornamento non riuscito',
    'profile.t.updateFailedDesc': 'Impossibile completare il profilo. Riprova.',
    'tier.choosePlan': 'Scegli il tuo piano di abbonamento',
    'tier.chooseDesc': 'Seleziona il piano più adatto alle esigenze della tua azienda',
    'tier.trialTitle': 'Prova Servisfy gratis per 14 giorni',
    'tier.trialDesc': 'Tutte le funzionalità Professional. Nessuna carta richiesta. Passa a un piano a pagamento quando vuoi prima della fine della prova.',
    'tier.startingTrial': 'Avvio della prova…',
    'tier.startTrial': 'Inizia la prova gratuita di 14 giorni',
    'tier.popular': 'Popolare',
    'tier.onRequest': 'Su richiesta',
    'tier.users': 'Utenti:',
    'tier.engagements': 'Interazioni:',
    'tier.storage': 'Archiviazione:',
    'tier.selected': 'Selezionato',
    'tier.selectedLabel': 'Selezionato:',
    'tier.contactSales': 'Contatta le vendite',
    'tier.customPlanNote': 'I piani personalizzati sono su misura: il nostro team configurerà il tuo prezzo',
    'tier.redirecting': 'Reindirizzamento al pagamento…',
    'tier.continuePayment': 'Continua al pagamento',
    'tier.securePayment': "Verrai reindirizzato a un'elaborazione del pagamento sicura",
    'success.confirming': 'Conferma del pagamento in corso…',
    'success.trialActive': 'La tua prova è attiva!',
    'success.welcome': 'Benvenuto a bordo!',
    'success.paymentIncomplete': 'Pagamento incompleto',
    'success.stillProcessing': 'Elaborazione in corso…',
    'success.trialLive': 'La tua prova gratuita di 14 giorni è attiva. Salva il tuo ID marchio: il tuo team lo userà per registrarsi.',
    'success.subActive': 'Il tuo abbonamento è attivo. Salva il tuo ID marchio: il tuo personale lo userà per registrarsi.',
    'success.yourBrandId': 'Il tuo ID marchio',
    'success.trialEnds': 'La prova termina:',
    'success.tierTrial': '{tier} (prova)',
    'success.tierPlan': 'Piano {tier}',
    'success.continueLogin': "Continua all'accesso",
    'success.paymentFailed': 'Non siamo riusciti a confermare il tuo pagamento. Riprova.',
    'success.backToSignup': 'Torna alla registrazione',
    'success.stillProcessingDesc': 'Il pagamento è ancora in elaborazione. Controlla la tua email per la ricevuta; potrai accedere una volta completato.',
    'cancel.title': 'Pagamento annullato',
    'cancel.desc': 'Nessun addebito è stato effettuato. Puoi riprendere la registrazione in qualsiasi momento.',
  },
  ja: {
    'staff.registration': 'スタッフ登録',
    'staff.joinTeam': 'ビジネスチームに参加',
    'staff.joinDesc': 'ビジネスのブランドIDを使ってスタッフとして登録します',
    'staff.processTitle': 'スタッフ登録の流れ',
    'staff.process1': 'ビジネスのブランドIDを入力してください（管理者から提供される8桁のコード）',
    'staff.process2': 'すべてのスタッフはオペレーターの役割から始まります',
    'staff.process3': '管理者は後で別の役割を割り当てることができます',
    'staff.process4': '各ビジネスは自社のデータに分離してアクセスします',
    'staff.brandIdLabel': 'ビジネスのブランドID *',
    'staff.brandIdPh': 'ブランドIDを入力してください',
    'staff.verify': '確認',
    'staff.getFromAdmin': 'ビジネス管理者から取得してください',
    'staff.needBrandId': 'ブランドIDが必要ですか？',
    'staff.contactAdminPre': 'ブランドIDを取得するにはビジネス管理者にお問い合わせください。ビジネスオーナーの方は、',
    'staff.createBusinessLink': 'ビジネスアカウントを作成',
    'staff.contactAdminPost': 'してください。',
    'staff.brandIdVerified': 'ブランドIDが確認されました',
    'staff.sectorLabel': '業種：',
    'staff.subSectorLabel': 'サブ業種：',
    'staff.personalInfo': '個人情報',
    'staff.emailLabel': 'メールアドレス *',
    'staff.emailPh': 'メールアドレスを入力してください',
    'staff.contact': '連絡先',
    'staff.phoneHelper': '国番号を選択して電話番号を入力してください。この番号を使ってOTPでログインします。',
    'staff.defaultRole': 'デフォルトの役割の割り当て',
    'staff.roleInfo': '最初はオペレーターの役割が割り当てられます。管理者は後で役割を更新できます。',
    'staff.creating': 'アカウントを作成中...',
    'staff.createAccount': 'スタッフアカウントを作成',
    'staff.accountCreated': 'アカウントが正常に作成されました！',
    'staff.regDetails': '登録の詳細',
    'staff.businessLabel': 'ビジネス：',
    'staff.brandIdColon': 'ブランドID：',
    'staff.initialRole': '初期の役割：',
    'staff.activeLogin': 'アカウントは有効です。電話番号でログインしてください。本人確認のためOTPが送信されます。',
    'staff.t.brandRequiredTitle': 'ブランドIDが必要です',
    'staff.t.brandRequiredDesc': '管理者から提供されたブランドIDを入力してください。',
    'staff.t.verifiedTitle': 'ブランドIDが確認されました！',
    'staff.t.verifiedDesc': '{business} に登録されます',
    'staff.t.invalidBrandTitle': '無効なブランドID',
    'staff.t.invalidBrandDesc': 'ブランドIDが見つかりません。管理者にご確認ください。',
    'staff.t.couldNotVerifyTitle': 'ブランドIDを確認できませんでした',
    'staff.t.couldNotVerifyDesc': 'もう一度お試しいただくか、管理者にお問い合わせください。',
    'staff.t.connErrorTitle': '接続エラー',
    'staff.t.connVerifyDesc': 'ブランドIDを確認するためにサーバーに接続できませんでした。もう一度お試しください。',
    'staff.t.invalidPhoneTitle': '無効な電話番号',
    'staff.t.invalidPhoneDesc': '国番号を選択し、有効な電話番号を入力してください。',
    'staff.t.phoneRegisteredTitle': '電話番号は既に登録されています',
    'staff.t.phoneRegisteredDesc': 'この電話番号は既に別のビジネスアカウントに登録されています。',
    'staff.t.inviteExpiredTitle': '招待の有効期限が切れました',
    'staff.t.inviteExpiredDesc': 'この招待は有効期限が切れています。新しい招待をリクエストするには管理者にお問い合わせください。',
    'staff.t.regBlockedTitle': '登録がブロックされました',
    'staff.t.regBlockedDesc': '席数の上限に達したか、このプランでは役割を利用できません。',
    'staff.t.brandNotFoundTitle': 'ブランドIDが見つかりません',
    'staff.t.brandNotFoundDesc': 'このブランドIDは存在しません。管理者にご確認ください。',
    'staff.t.regFailedTitle': '登録に失敗しました',
    'staff.t.regFailedDesc': '登録を完了できませんでした。もう一度お試しください。',
    'staff.t.accountCreatedTitle': 'アカウントが作成されました！',
    'staff.t.accountCreatedDesc': 'スタッフアカウントが有効になりました。電話番号でログインできます。',
    'staff.t.connDesc': 'サーバーに接続できませんでした。もう一度お試しください。',
    'profile.title': 'プロフィールを完成させる',
    'profile.desc': 'お名前を入力して、体験をパーソナライズしましょう',
    'profile.firstName': '名 *',
    'profile.firstNamePh': '太郎',
    'profile.lastName': '姓',
    'profile.lastNamePh': '山田',
    'profile.company': '会社（任意）',
    'profile.companyPh': '会社名',
    'profile.saving': '保存中...',
    'profile.complete': 'プロフィールを完成',
    'profile.t.nameRequiredTitle': '名前が必要です',
    'profile.t.nameRequiredDesc': '名を入力してください',
    'profile.t.completedTitle': 'プロフィールが完成しました',
    'profile.t.completedDesc': 'ようこそ、{name} さん！',
    'profile.t.updateFailedTitle': '更新に失敗しました',
    'profile.t.updateFailedDesc': 'プロフィールを完成できませんでした。もう一度お試しください。',
    'tier.choosePlan': 'サブスクリプションプランを選択',
    'tier.chooseDesc': 'ビジネスのニーズに最も適したプランを選択してください',
    'tier.trialTitle': 'Servisfyを14日間無料でお試しください',
    'tier.trialDesc': 'すべてのProfessional機能。カード不要。トライアル終了前ならいつでも有料プランに変更できます。',
    'tier.startingTrial': 'トライアルを開始しています…',
    'tier.startTrial': '14日間の無料トライアルを開始',
    'tier.popular': '人気',
    'tier.onRequest': 'お問い合わせ',
    'tier.users': 'ユーザー：',
    'tier.engagements': 'エンゲージメント：',
    'tier.storage': 'ストレージ：',
    'tier.selected': '選択済み',
    'tier.selectedLabel': '選択中：',
    'tier.contactSales': '営業に問い合わせる',
    'tier.customPlanNote': 'カスタムプランはお客様に合わせて調整されます。担当チームが料金を設定します',
    'tier.redirecting': '支払いにリダイレクトしています…',
    'tier.continuePayment': '支払いに進む',
    'tier.securePayment': '安全な支払い処理にリダイレクトされます',
    'success.confirming': 'お支払いを確認しています…',
    'success.trialActive': 'トライアルが有効になりました！',
    'success.welcome': 'ようこそ！',
    'success.paymentIncomplete': '支払いが未完了です',
    'success.stillProcessing': '処理中です…',
    'success.trialLive': '14日間の無料トライアルが有効です。ブランドIDを保存してください。チームが登録に使用します。',
    'success.subActive': 'サブスクリプションが有効です。ブランドIDを保存してください。スタッフが登録に使用します。',
    'success.yourBrandId': 'あなたのブランドID',
    'success.trialEnds': 'トライアル終了：',
    'success.tierTrial': '{tier}（トライアル）',
    'success.tierPlan': '{tier} プラン',
    'success.continueLogin': 'ログインに進む',
    'success.paymentFailed': 'お支払いを確認できませんでした。もう一度お試しください。',
    'success.backToSignup': '登録に戻る',
    'success.stillProcessingDesc': '支払いはまだ処理中です。領収書についてはメールをご確認ください。処理が完了するとログインできます。',
    'cancel.title': '支払いがキャンセルされました',
    'cancel.desc': '請求は発生していません。いつでも登録を再開できます。',
  },
  ko: {
    'staff.registration': '스태프 등록',
    'staff.joinTeam': '비즈니스 팀에 참여하기',
    'staff.joinDesc': '비즈니스 브랜드 ID를 사용하여 스태프로 등록하세요',
    'staff.processTitle': '스태프 등록 절차',
    'staff.process1': '비즈니스 브랜드 ID를 입력하세요 (관리자가 제공한 8자리 코드)',
    'staff.process2': '모든 스태프는 오퍼레이터 역할로 시작합니다',
    'staff.process3': '관리자가 나중에 다른 역할을 할당할 수 있습니다',
    'staff.process4': '각 비즈니스는 자체 데이터에 격리된 접근 권한을 가집니다',
    'staff.brandIdLabel': '비즈니스 브랜드 ID *',
    'staff.brandIdPh': '브랜드 ID를 입력하세요',
    'staff.verify': '확인',
    'staff.getFromAdmin': '비즈니스 관리자에게 문의하세요',
    'staff.needBrandId': '브랜드 ID가 필요하신가요?',
    'staff.contactAdminPre': '브랜드 ID를 받으려면 비즈니스 관리자에게 문의하세요. 비즈니스 소유자라면, ',
    'staff.createBusinessLink': '비즈니스 계정을 만드세요',
    'staff.contactAdminPost': '.',
    'staff.brandIdVerified': '브랜드 ID 확인됨',
    'staff.sectorLabel': '업종:',
    'staff.subSectorLabel': '세부 업종:',
    'staff.personalInfo': '개인 정보',
    'staff.emailLabel': '이메일 주소 *',
    'staff.emailPh': '이메일을 입력하세요',
    'staff.contact': '연락처',
    'staff.phoneHelper': '국가 번호를 선택한 후 전화번호를 입력하세요. 이 번호로 OTP를 통해 로그인합니다.',
    'staff.defaultRole': '기본 역할 할당',
    'staff.roleInfo': '처음에는 오퍼레이터 역할이 할당됩니다. 관리자가 나중에 역할을 업데이트할 수 있습니다.',
    'staff.creating': '계정 생성 중...',
    'staff.createAccount': '스태프 계정 만들기',
    'staff.accountCreated': '계정이 성공적으로 생성되었습니다!',
    'staff.regDetails': '등록 세부 정보',
    'staff.businessLabel': '비즈니스:',
    'staff.brandIdColon': '브랜드 ID:',
    'staff.initialRole': '초기 역할:',
    'staff.activeLogin': '계정이 활성화되었습니다. 전화번호로 로그인하세요. 본인 확인을 위한 OTP를 받게 됩니다.',
    'staff.t.brandRequiredTitle': '브랜드 ID 필요',
    'staff.t.brandRequiredDesc': '관리자가 제공한 브랜드 ID를 입력하세요.',
    'staff.t.verifiedTitle': '브랜드 ID 확인됨!',
    'staff.t.verifiedDesc': '{business}에 등록됩니다',
    'staff.t.invalidBrandTitle': '잘못된 브랜드 ID',
    'staff.t.invalidBrandDesc': '브랜드 ID를 찾을 수 없습니다. 관리자에게 확인하세요.',
    'staff.t.couldNotVerifyTitle': '브랜드 ID를 확인할 수 없습니다',
    'staff.t.couldNotVerifyDesc': '다시 시도하거나 관리자에게 문의하세요.',
    'staff.t.connErrorTitle': '연결 오류',
    'staff.t.connVerifyDesc': '브랜드 ID를 확인하기 위해 서버에 연결할 수 없습니다. 다시 시도하세요.',
    'staff.t.invalidPhoneTitle': '잘못된 전화번호',
    'staff.t.invalidPhoneDesc': '국가 번호를 선택하고 유효한 전화번호를 입력하세요.',
    'staff.t.phoneRegisteredTitle': '이미 등록된 전화번호',
    'staff.t.phoneRegisteredDesc': '이 전화번호는 이미 다른 비즈니스 계정에 등록되어 있습니다.',
    'staff.t.inviteExpiredTitle': '초대 만료됨',
    'staff.t.inviteExpiredDesc': '이 초대는 만료되었습니다. 새 초대를 요청하려면 관리자에게 문의하세요.',
    'staff.t.regBlockedTitle': '등록 차단됨',
    'staff.t.regBlockedDesc': '좌석 한도에 도달했거나 이 요금제에서 역할을 사용할 수 없습니다.',
    'staff.t.brandNotFoundTitle': '브랜드 ID를 찾을 수 없음',
    'staff.t.brandNotFoundDesc': '이 브랜드 ID는 존재하지 않습니다. 관리자에게 확인하세요.',
    'staff.t.regFailedTitle': '등록 실패',
    'staff.t.regFailedDesc': '등록을 완료할 수 없습니다. 다시 시도하세요.',
    'staff.t.accountCreatedTitle': '계정 생성됨!',
    'staff.t.accountCreatedDesc': '스태프 계정이 활성화되었습니다. 이제 전화번호로 로그인할 수 있습니다.',
    'staff.t.connDesc': '서버에 연결할 수 없습니다. 다시 시도하세요.',
    'profile.title': '프로필 완성하기',
    'profile.desc': '이름을 입력하여 경험을 개인화할 수 있도록 도와주세요',
    'profile.firstName': '이름 *',
    'profile.firstNamePh': '길동',
    'profile.lastName': '성',
    'profile.lastNamePh': '홍',
    'profile.company': '회사 (선택 사항)',
    'profile.companyPh': '회사명',
    'profile.saving': '저장 중...',
    'profile.complete': '프로필 완성',
    'profile.t.nameRequiredTitle': '이름 필요',
    'profile.t.nameRequiredDesc': '이름을 입력하세요',
    'profile.t.completedTitle': '프로필 완성됨',
    'profile.t.completedDesc': '환영합니다, {name}님!',
    'profile.t.updateFailedTitle': '업데이트 실패',
    'profile.t.updateFailedDesc': '프로필을 완성할 수 없습니다. 다시 시도하세요.',
    'tier.choosePlan': '구독 요금제 선택',
    'tier.chooseDesc': '비즈니스 요구 사항에 가장 적합한 요금제를 선택하세요',
    'tier.trialTitle': 'Servisfy를 14일 동안 무료로 사용해 보세요',
    'tier.trialDesc': '모든 Professional 기능. 카드 불필요. 체험 기간이 끝나기 전 언제든지 유료 요금제로 전환하세요.',
    'tier.startingTrial': '체험을 시작하는 중…',
    'tier.startTrial': '14일 무료 체험 시작',
    'tier.popular': '인기',
    'tier.onRequest': '문의',
    'tier.users': '사용자:',
    'tier.engagements': '인게이지먼트:',
    'tier.storage': '저장 용량:',
    'tier.selected': '선택됨',
    'tier.selectedLabel': '선택됨:',
    'tier.contactSales': '영업팀에 문의',
    'tier.customPlanNote': '맞춤형 요금제는 고객에 맞게 조정됩니다. 담당 팀이 가격을 설정합니다',
    'tier.redirecting': '결제로 이동 중…',
    'tier.continuePayment': '결제 계속하기',
    'tier.securePayment': '보안 결제 처리로 리디렉션됩니다',
    'success.confirming': '결제를 확인하는 중…',
    'success.trialActive': '체험이 활성화되었습니다!',
    'success.welcome': '함께하게 되어 환영합니다!',
    'success.paymentIncomplete': '결제 미완료',
    'success.stillProcessing': '아직 처리 중…',
    'success.trialLive': '14일 무료 체험이 활성화되었습니다. 브랜드 ID를 저장하세요. 팀원이 가입에 사용합니다.',
    'success.subActive': '구독이 활성화되었습니다. 브랜드 ID를 저장하세요. 스태프가 가입에 사용합니다.',
    'success.yourBrandId': '귀하의 브랜드 ID',
    'success.trialEnds': '체험 종료:',
    'success.tierTrial': '{tier} (체험)',
    'success.tierPlan': '{tier} 요금제',
    'success.continueLogin': '로그인으로 계속하기',
    'success.paymentFailed': '결제를 확인할 수 없습니다. 다시 시도하세요.',
    'success.backToSignup': '가입으로 돌아가기',
    'success.stillProcessingDesc': '결제가 아직 처리 중입니다. 영수증은 이메일을 확인하세요. 처리가 완료되면 로그인할 수 있습니다.',
    'cancel.title': '결제 취소됨',
    'cancel.desc': '청구된 금액이 없습니다. 언제든지 가입을 다시 시작할 수 있습니다.',
  },
  zh: {
    'staff.registration': '员工注册',
    'staff.joinTeam': '加入您的企业团队',
    'staff.joinDesc': '使用您企业的品牌 ID 注册为员工',
    'staff.processTitle': '员工注册流程',
    'staff.process1': '输入您企业的品牌 ID（管理员提供的 8 位代码）',
    'staff.process2': '所有员工都从操作员角色开始',
    'staff.process3': '管理员稍后可以分配不同的角色',
    'staff.process4': '每个企业对其数据都有隔离的访问权限',
    'staff.brandIdLabel': '企业品牌 ID *',
    'staff.brandIdPh': '输入您的品牌 ID',
    'staff.verify': '验证',
    'staff.getFromAdmin': '向您的企业管理员获取',
    'staff.needBrandId': '需要品牌 ID 吗？',
    'staff.contactAdminPre': '请联系您的企业管理员获取品牌 ID。如果您是企业所有者，请改为',
    'staff.createBusinessLink': '创建企业账户',
    'staff.contactAdminPost': '。',
    'staff.brandIdVerified': '品牌 ID 已验证',
    'staff.sectorLabel': '行业：',
    'staff.subSectorLabel': '子行业：',
    'staff.personalInfo': '个人信息',
    'staff.emailLabel': '电子邮件地址 *',
    'staff.emailPh': '输入您的电子邮件',
    'staff.contact': '联系方式',
    'staff.phoneHelper': '选择您的国家代码，然后输入您的号码。您将使用此号码通过 OTP 登录。',
    'staff.defaultRole': '默认角色分配',
    'staff.roleInfo': '您最初将被分配操作员角色。您的管理员稍后可以更新您的角色。',
    'staff.creating': '正在创建账户...',
    'staff.createAccount': '创建员工账户',
    'staff.accountCreated': '账户创建成功！',
    'staff.regDetails': '注册详情',
    'staff.businessLabel': '企业：',
    'staff.brandIdColon': '品牌 ID：',
    'staff.initialRole': '初始角色：',
    'staff.activeLogin': '您的账户已激活。使用您的电话号码登录；您将收到一个 OTP 以验证您的身份。',
    'staff.t.brandRequiredTitle': '需要品牌 ID',
    'staff.t.brandRequiredDesc': '请输入管理员提供的品牌 ID。',
    'staff.t.verifiedTitle': '品牌 ID 已验证！',
    'staff.t.verifiedDesc': '您将注册到 {business}',
    'staff.t.invalidBrandTitle': '无效的品牌 ID',
    'staff.t.invalidBrandDesc': '未找到品牌 ID。请与您的管理员核对。',
    'staff.t.couldNotVerifyTitle': '无法验证品牌 ID',
    'staff.t.couldNotVerifyDesc': '请重试或联系您的管理员。',
    'staff.t.connErrorTitle': '连接错误',
    'staff.t.connVerifyDesc': '无法连接服务器以验证您的品牌 ID。请重试。',
    'staff.t.invalidPhoneTitle': '无效的电话号码',
    'staff.t.invalidPhoneDesc': '选择您的国家代码并输入有效的电话号码。',
    'staff.t.phoneRegisteredTitle': '电话号码已注册',
    'staff.t.phoneRegisteredDesc': '此电话号码已在另一个企业账户下注册。',
    'staff.t.inviteExpiredTitle': '邀请已过期',
    'staff.t.inviteExpiredDesc': '此邀请已过期。请联系您的管理员请求新的邀请。',
    'staff.t.regBlockedTitle': '注册被阻止',
    'staff.t.regBlockedDesc': '已达到席位上限，或此套餐不提供该角色。',
    'staff.t.brandNotFoundTitle': '未找到品牌 ID',
    'staff.t.brandNotFoundDesc': '此品牌 ID 不存在。请与您的管理员核对。',
    'staff.t.regFailedTitle': '注册失败',
    'staff.t.regFailedDesc': '无法完成注册。请重试。',
    'staff.t.accountCreatedTitle': '账户已创建！',
    'staff.t.accountCreatedDesc': '您的员工账户已激活。您现在可以使用电话号码登录。',
    'staff.t.connDesc': '无法连接服务器。请重试。',
    'profile.title': '完善您的个人资料',
    'profile.desc': '请提供您的姓名，以帮助我们为您个性化体验',
    'profile.firstName': '名字 *',
    'profile.firstNamePh': '小明',
    'profile.lastName': '姓氏',
    'profile.lastNamePh': '王',
    'profile.company': '公司（可选）',
    'profile.companyPh': '您的公司名称',
    'profile.saving': '正在保存...',
    'profile.complete': '完成个人资料',
    'profile.t.nameRequiredTitle': '需要姓名',
    'profile.t.nameRequiredDesc': '请输入您的名字',
    'profile.t.completedTitle': '个人资料已完成',
    'profile.t.completedDesc': '欢迎，{name}！',
    'profile.t.updateFailedTitle': '更新失败',
    'profile.t.updateFailedDesc': '无法完成个人资料。请重试。',
    'tier.choosePlan': '选择您的订阅套餐',
    'tier.chooseDesc': '选择最适合您企业需求的套餐',
    'tier.trialTitle': '免费试用 Servisfy 14 天',
    'tier.trialDesc': '完整的 Professional 功能。无需信用卡。可在试用结束前随时转为付费套餐。',
    'tier.startingTrial': '正在开始您的试用…',
    'tier.startTrial': '开始 14 天免费试用',
    'tier.popular': '热门',
    'tier.onRequest': '按需定制',
    'tier.users': '用户：',
    'tier.engagements': '互动次数：',
    'tier.storage': '存储空间：',
    'tier.selected': '已选择',
    'tier.selectedLabel': '已选择：',
    'tier.contactSales': '联系销售',
    'tier.customPlanNote': '定制套餐将为您量身打造，我们的团队将为您设置价格',
    'tier.redirecting': '正在跳转到付款…',
    'tier.continuePayment': '继续付款',
    'tier.securePayment': '您将被重定向到安全的付款处理',
    'success.confirming': '正在确认您的付款…',
    'success.trialActive': '您的试用已激活！',
    'success.welcome': '欢迎加入！',
    'success.paymentIncomplete': '付款未完成',
    'success.stillProcessing': '仍在处理…',
    'success.trialLive': '您的 14 天免费试用已生效。请保存您的品牌 ID，您的团队将用它来注册。',
    'success.subActive': '您的订阅已激活。请保存您的品牌 ID，您的员工将用它来注册。',
    'success.yourBrandId': '您的品牌 ID',
    'success.trialEnds': '试用结束：',
    'success.tierTrial': '{tier}（试用）',
    'success.tierPlan': '{tier} 套餐',
    'success.continueLogin': '继续登录',
    'success.paymentFailed': '我们无法确认您的付款。请重试。',
    'success.backToSignup': '返回注册',
    'success.stillProcessingDesc': '付款仍在处理中。请查看您的电子邮件获取收据；处理完成后即可登录。',
    'cancel.title': '付款已取消',
    'cancel.desc': '未产生任何费用。您可以随时继续注册。',
  },
  ar: {
    'staff.registration': 'تسجيل الموظفين',
    'staff.joinTeam': 'انضم إلى فريق عملك',
    'staff.joinDesc': 'سجّل كموظف باستخدام معرّف العلامة التجارية الخاص بعملك',
    'staff.processTitle': 'عملية تسجيل الموظفين',
    'staff.process1': 'أدخل معرّف العلامة التجارية لعملك (رمز مكوّن من 8 أرقام من المسؤول)',
    'staff.process2': 'يبدأ جميع الموظفين بدور المشغّل',
    'staff.process3': 'يمكن للمسؤول تعيين أدوار مختلفة لاحقًا',
    'staff.process4': 'لكل عمل وصول معزول إلى بياناته',
    'staff.brandIdLabel': 'معرّف العلامة التجارية للعمل *',
    'staff.brandIdPh': 'أدخل معرّف العلامة التجارية الخاص بك',
    'staff.verify': 'تحقّق',
    'staff.getFromAdmin': 'احصل عليه من مسؤول عملك',
    'staff.needBrandId': 'هل تحتاج إلى معرّف علامة تجارية؟',
    'staff.contactAdminPre': 'تواصل مع مسؤول عملك للحصول على معرّف العلامة التجارية. إذا كنت صاحب عمل، ',
    'staff.createBusinessLink': 'أنشئ حساب عمل',
    'staff.contactAdminPost': ' بدلاً من ذلك.',
    'staff.brandIdVerified': 'تم التحقق من معرّف العلامة التجارية',
    'staff.sectorLabel': 'القطاع:',
    'staff.subSectorLabel': 'القطاع الفرعي:',
    'staff.personalInfo': 'المعلومات الشخصية',
    'staff.emailLabel': 'عنوان البريد الإلكتروني *',
    'staff.emailPh': 'أدخل بريدك الإلكتروني',
    'staff.contact': 'جهة الاتصال',
    'staff.phoneHelper': 'اختر رمز بلدك ثم أدخل رقمك. ستستخدم هذا الرقم لتسجيل الدخول عبر رمز التحقق OTP.',
    'staff.defaultRole': 'تعيين الدور الافتراضي',
    'staff.roleInfo': 'سيتم تعيين دور المشغّل لك في البداية. يمكن لمسؤولك تحديث دورك لاحقًا.',
    'staff.creating': 'جارٍ إنشاء الحساب...',
    'staff.createAccount': 'إنشاء حساب موظف',
    'staff.accountCreated': 'تم إنشاء الحساب بنجاح!',
    'staff.regDetails': 'تفاصيل التسجيل',
    'staff.businessLabel': 'العمل:',
    'staff.brandIdColon': 'معرّف العلامة التجارية:',
    'staff.initialRole': 'الدور الأولي:',
    'staff.activeLogin': 'حسابك نشط. سجّل الدخول برقم هاتفك؛ ستتلقى رمز تحقق OTP للتحقق من هويتك.',
    'staff.t.brandRequiredTitle': 'معرّف العلامة التجارية مطلوب',
    'staff.t.brandRequiredDesc': 'أدخل معرّف العلامة التجارية من مسؤولك.',
    'staff.t.verifiedTitle': 'تم التحقق من معرّف العلامة التجارية!',
    'staff.t.verifiedDesc': 'سيتم تسجيلك ضمن {business}',
    'staff.t.invalidBrandTitle': 'معرّف علامة تجارية غير صالح',
    'staff.t.invalidBrandDesc': 'لم يتم العثور على معرّف العلامة التجارية. يرجى التحقق مع مسؤولك.',
    'staff.t.couldNotVerifyTitle': 'تعذّر التحقق من معرّف العلامة التجارية',
    'staff.t.couldNotVerifyDesc': 'يرجى المحاولة مرة أخرى أو التواصل مع مسؤولك.',
    'staff.t.connErrorTitle': 'خطأ في الاتصال',
    'staff.t.connVerifyDesc': 'تعذّر الوصول إلى الخادم للتحقق من معرّف العلامة التجارية. يرجى المحاولة مرة أخرى.',
    'staff.t.invalidPhoneTitle': 'رقم هاتف غير صالح',
    'staff.t.invalidPhoneDesc': 'اختر رمز بلدك وأدخل رقم هاتف صالحًا.',
    'staff.t.phoneRegisteredTitle': 'الهاتف مسجّل بالفعل',
    'staff.t.phoneRegisteredDesc': 'رقم الهاتف هذا مسجّل بالفعل ضمن حساب عمل آخر.',
    'staff.t.inviteExpiredTitle': 'انتهت صلاحية الدعوة',
    'staff.t.inviteExpiredDesc': 'انتهت صلاحية هذه الدعوة. تواصل مع مسؤولك لطلب دعوة جديدة.',
    'staff.t.regBlockedTitle': 'تم حظر التسجيل',
    'staff.t.regBlockedDesc': 'تم الوصول إلى حد المقاعد أو أن الدور غير متاح في هذه الخطة.',
    'staff.t.brandNotFoundTitle': 'لم يتم العثور على معرّف العلامة التجارية',
    'staff.t.brandNotFoundDesc': 'معرّف العلامة التجارية هذا غير موجود. تحقّق مع مسؤولك.',
    'staff.t.regFailedTitle': 'فشل التسجيل',
    'staff.t.regFailedDesc': 'تعذّر إكمال التسجيل. يرجى المحاولة مرة أخرى.',
    'staff.t.accountCreatedTitle': 'تم إنشاء الحساب!',
    'staff.t.accountCreatedDesc': 'حساب الموظف الخاص بك نشط. يمكنك الآن تسجيل الدخول برقم هاتفك.',
    'staff.t.connDesc': 'تعذّر الوصول إلى الخادم. يرجى المحاولة مرة أخرى.',
    'profile.title': 'أكمل ملفك الشخصي',
    'profile.desc': 'ساعدنا في تخصيص تجربتك من خلال تقديم اسمك',
    'profile.firstName': 'الاسم الأول *',
    'profile.firstNamePh': 'محمد',
    'profile.lastName': 'اسم العائلة',
    'profile.lastNamePh': 'أحمد',
    'profile.company': 'الشركة (اختياري)',
    'profile.companyPh': 'اسم شركتك',
    'profile.saving': 'جارٍ الحفظ...',
    'profile.complete': 'إكمال الملف الشخصي',
    'profile.t.nameRequiredTitle': 'الاسم مطلوب',
    'profile.t.nameRequiredDesc': 'يرجى إدخال اسمك الأول',
    'profile.t.completedTitle': 'اكتمل الملف الشخصي',
    'profile.t.completedDesc': 'مرحبًا، {name}!',
    'profile.t.updateFailedTitle': 'فشل التحديث',
    'profile.t.updateFailedDesc': 'تعذّر إكمال الملف الشخصي. يرجى المحاولة مرة أخرى.',
    'tier.choosePlan': 'اختر خطة اشتراكك',
    'tier.chooseDesc': 'اختر الخطة التي تناسب احتياجات عملك بشكل أفضل',
    'tier.trialTitle': 'جرّب Servisfy مجانًا لمدة 14 يومًا',
    'tier.trialDesc': 'جميع ميزات Professional. لا حاجة إلى بطاقة. يمكنك التحويل إلى خطة مدفوعة في أي وقت قبل انتهاء فترتك التجريبية.',
    'tier.startingTrial': 'جارٍ بدء فترتك التجريبية…',
    'tier.startTrial': 'ابدأ الفترة التجريبية المجانية لمدة 14 يومًا',
    'tier.popular': 'الأكثر رواجًا',
    'tier.onRequest': 'عند الطلب',
    'tier.users': 'المستخدمون:',
    'tier.engagements': 'التفاعلات:',
    'tier.storage': 'التخزين:',
    'tier.selected': 'محدد',
    'tier.selectedLabel': 'المحدد:',
    'tier.contactSales': 'تواصل مع المبيعات',
    'tier.customPlanNote': 'الخطط المخصّصة مصممة خصيصًا لك — سيقوم فريقنا بإعداد أسعارك',
    'tier.redirecting': 'جارٍ إعادة التوجيه إلى الدفع…',
    'tier.continuePayment': 'المتابعة إلى الدفع',
    'tier.securePayment': 'ستتم إعادة توجيهك إلى معالجة دفع آمنة',
    'success.confirming': 'جارٍ تأكيد دفعتك…',
    'success.trialActive': 'فترتك التجريبية نشطة!',
    'success.welcome': 'مرحبًا بك معنا!',
    'success.paymentIncomplete': 'الدفع غير مكتمل',
    'success.stillProcessing': 'لا تزال قيد المعالجة…',
    'success.trialLive': 'فترتك التجريبية المجانية لمدة 14 يومًا نشطة. احفظ معرّف علامتك التجارية — سيستخدمه فريقك للتسجيل.',
    'success.subActive': 'اشتراكك نشط. احفظ معرّف علامتك التجارية — سيستخدمه موظفوك للتسجيل.',
    'success.yourBrandId': 'معرّف علامتك التجارية',
    'success.trialEnds': 'تنتهي الفترة التجريبية:',
    'success.tierTrial': '{tier} (تجريبي)',
    'success.tierPlan': 'خطة {tier}',
    'success.continueLogin': 'المتابعة إلى تسجيل الدخول',
    'success.paymentFailed': 'لم نتمكن من تأكيد دفعتك. يرجى المحاولة مرة أخرى.',
    'success.backToSignup': 'العودة إلى التسجيل',
    'success.stillProcessingDesc': 'لا يزال الدفع قيد المعالجة. تحقق من بريدك الإلكتروني للحصول على الإيصال؛ يمكنك تسجيل الدخول بمجرد اكتماله.',
    'cancel.title': 'تم إلغاء الدفع',
    'cancel.desc': 'لم يتم إجراء أي رسوم. يمكنك استئناف التسجيل في أي وقت.',
  },
};

export default authExtraTranslations;
